import React, { useEffect, useState, useMemo } from 'react';
import classNames from 'classnames';

import style from './style.module.css';
import typ from 'design-v2/globals/typography.module.css';
import color from 'design-v2/globals/colors/colors.module.css';

import { ICustomerDetailInput } from './types';
import { InputAdornment, TextField as MuiTextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import IconsService from 'external-services/icons-service/icons.service';

const CustomerDetailInput = (props: ICustomerDetailInput) => {

  const {
    icon,
    placeholder,
    detail,
    handleChange,
    handleCustomerTouched,
    inputOnFocus,
    disabled = false,
    themeProps = {}
  } = props;

  const Icon = IconsService.getIcon(icon);

  const [value, setValue] = useState(detail);

  useEffect(() => {
    setValue(detail);
  }, [detail]);

  const _handleChange = (e: any) => {
    setValue(e.target.value);
    handleChange(e.target.value);
  };

  const TextField = useMemo(
    () =>
      withStyles(themeProps)(MuiTextField),
    []
  );

  return (
    <div>
      <TextField
        fullWidth
        InputProps={{
          className: classNames({
            [style.input]: true,
            [typ.typSize2]: true,
            [typ.typReg]: true,
          }),
          placeholder: placeholder,
          startAdornment: (
            <InputAdornment position="start">
              {icon && (
                <Icon
                  className={classNames({
                    [color.clrGreyHeavy]: true,
                  })}
                />)}
                {(!icon && props.muiIcon) ? <div style={{width:24, height: 24}}>{props.muiIcon}</div> : null}
              </InputAdornment>
            ),
          }}
          value={value}
          onChange={_handleChange}
          onBlur={handleCustomerTouched}
          disabled={disabled}
          onFocus={() => inputOnFocus && inputOnFocus()}
        />
    </div>
  );
};

export default CustomerDetailInput;
